
"use client";


import { Link } from "@heroui/link";
import { Snippet } from "@heroui/snippet";
import { Code } from "@heroui/code";
import { button as buttonStyles } from "@heroui/theme";

import { siteConfig } from "@/config/site";
import { title, subtitle } from "@/components/primitives";
import React, { useCallback, useMemo, useRef } from 'react';
import { useScroll, useTransform, useMotionValueEvent } from "framer-motion";
import { Image } from "@heroui/image";



export default function WorkoutGym() {

  const BackgroundRef = useRef<HTMLCanvasElement>(null);
  const BackGroundScroll = useRef<HTMLDivElement>(null);
  const BackGroundOverlay = useRef<HTMLCanvasElement>(null);

  var SubImage: {
    new(width?: number, height?: number): HTMLImageElement;
  };

  try{
    let img = document.createElement('img');
    img.src = '/images/gym_001/ezgif-frame-000.jpg';

    }catch{}

  const { scrollYProgress} = useScroll({
      target: BackGroundScroll,
      offset: ['end end',  'start start'],
    });

    var BackgroundImages : HTMLImageElement[] = []
    
    const RefreshPictures = () => {
      
      const BackgroundImages_Loaded: HTMLImageElement[] = [];

      for (let j = 1; j<= 87; j++){
        try{
        let img = document.createElement('img');
        img.src = '/images/gym_001/ezgif-frame-'+ Number(j).toString().padStart(3, '0') +'.jpg';
        BackgroundImages_Loaded.push(img); 
        }catch{}
      }
      BackgroundImages = BackgroundImages_Loaded;
    }

    if (typeof window !== "undefined") {
      window.addEventListener('load', RefreshPictures);
    }

    RefreshPictures();

  const BackgroundImage_Index = useTransform(scrollYProgress, [1, 0], [0, 64]);

  const render = useCallback((index:number) => {
    if(BackgroundImages[index]){

      
        var iw=Number(BackgroundImages[index].width);
        var ih=Number(BackgroundImages[index].height);

        BackgroundRef.current?.setAttribute("width", iw.toString());
        BackgroundRef.current?.setAttribute("height", ih.toString());
        
        var ShadowEnd = 0;
        if (index < 10){
          ShadowEnd = ((10 - index) / 10) * 0.2;
        }

      const ctx = BackgroundRef.current?.getContext('2d');
      if (ctx){
        ctx.drawImage(BackgroundImages[index],0,0);

        //let grad = ctx.createLinearGradient(0,0,iw,ih)
        //grad.addColorStop(0, '#000000fF');
        //grad.addColorStop(Number(ShadowEnd), "#00000000");
        //ctx.fillStyle = grad as CanvasGradient;
        //ctx.fillRect(0,0,800,800);
      }
    }},
      [BackgroundImages]
    );

    useMotionValueEvent(BackgroundImage_Index, 'change', (latest) => {
      render(Number(latest.toFixed()));
    });
  return (
    <div ref={BackGroundScroll} style={{height:"3200px", width: "100%"}}>

        <canvas ref={BackgroundRef} style={{left: "0", top:"60px", width:"100%", position:"fixed", zIndex:"5",}}/>
      <section className="flex flex-col items-center justify-center">
        <div className="inline-block text-center justify-center w-[90vW] max-w-[1000px] bg-white/80 gap-4 py-8 md:py-10 " style={{ zIndex:"10", position: "relative"}} >
          <div>
            <h1 className={title()}>Posilovna</h1>
            <div className={subtitle({ class: "mt-4 px-4"})} style={{textAlign:"left"}}>
              <div className="px-10 py-10 sm:w-lg w-full" style={{float: "left"}}>
                <Image className="w-lg"  src="/images/vstup.webp" />
              </div>
              <h1 className={title()}>Jste tu správně</h1>
              <p style={{textAlign:"left", textIndent:"30px"}}>
              Hledáte místo, kde nastartovat svou kondici, zlepšit sílu nebo si jen vyčistit hlavu po náročném dni? Právě pro vás jsme otevřeli novou posilovnu, která nabízí ideální zázemí pro začátečníky i pokročilé.
              </p>
              <p style={{textAlign:"left", textIndent:"30px"}}>
              Čeká na vás špičkové vybavení, příjemné prostředí a přátelská atmosféra, díky které se budete cítit dobře při každé návštěvě. Ať už preferujete silový trénink, kardio nebo funkční cvičení, u nás si najdete to své.
              </p>
              <p style={{textAlign:"left", textIndent:"30px"}}>
              Přijďte se přesvědčit sami a udělejte první krok ke zdravějšímu životnímu stylu. Těšíme se!
              </p>
          </div>
          </div>{
          //<span className={title()}>Make&nbsp;</span>
          //<span className={title({ color: "pink" })}>beautiful&nbsp;</span>
          //<br />
          //<span className={title()}>
          // websites regardless of your design experience.
          //</span>
          //<div className={subtitle({ class: "mt-4" })}>
          //  Beautiful, fast and modern React UI library.
         // </div>
         }
         
        </div>
    </section>
    </div>
  );
}
